// project imports
import { Navigate } from 'react-router-dom';
import { GuardProps } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import Loader from '@/ui-component/Loader';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, isInitializing } = useAppSelector((state) => state.auth);
    if (isInitializing) {
        return <Loader />;
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default AuthGuard;
